export default __webpack_public_path__ + "images/3dccb6f9147ef7b80efe23fe8025fc14.svg";